import { Services } from '@sigma-frontend-libs/commons'
import { EVENTSHISTORY_ASSOCIATED_SERVICES } from '@sigma-legacy-libs/essentials/lib/constants'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  computed: {
    rows() {
      const rows = []
      const excludeKeys = [ 'createdAt', 'updatedAt', 'User', 'data' ]
      for (const key in this.value) {
        if (excludeKeys.includes(key)) {
          continue
        }

        const result = {
          title: this.getTranslate(`${Services.eventsHistory}.labels.${key}`),
          copy: true,
          value: this.value[key]
        }
        switch (key) {
          case 'userId': {
            result.link = true
            result.to = {
              name: `${Services.users}.single`,
              params: { id: this.value[key] }
            }
            break
          }
          case 'entityId': {
            result.link = true
            result.to = {
              name: `${this.value.service}.single`,
              params: { id: this.value[key] }
            }

            switch (this.value.service) {
              case EVENTSHISTORY_ASSOCIATED_SERVICES.tasks: {
                result.to = {
                  name: Services.billings,
                  params: {
                    id: this.value.data.id,
                    createdAt: this.getCreatedAt()
                  },
                  query: { currentTab: Services.tasks }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.templates: {
                result.to = {
                  name: 'create',
                  params: { id: this.value.data.id }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.contactLists: {
                result.to = {
                  name: `${Services.contacts}.single`,
                  params: { id: this.value.data.id }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.billingsUsers: {
                result.to = {
                  name: Services.billings,
                  params: {
                    id: this.value.data.id,
                    createdAt: this.getCreatedAt()
                  },
                  query: { currentTab: Services.billings }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.contactListsContacts: {
                result.to = {
                  name: `${Services.contacts}.single`,
                  params: { id: this.value.data.ListId }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.keywordListsKeywords: {
                result.to = {
                  name: `${Services.keywordLists}.single`,
                  params: { id: this.value.data.ListId }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.permissionsUsers: {
                result.to = {
                  name: `${Services.users}.single`,
                  params: { id: this.value.entityId },
                  query: { currentTab: Services.permissions }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.settingsUserUsers: {
                const [ settingKey ] = this.value?.data?.new?.field?.split('.') || []
                result.to = {
                  name: `${Services.users}.single`,
                  params: { id: this.value.entityId },
                  query: {
                    currentTab: Services.settingsUser,
                    settingKey
                  }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.tokensUsers: {
                result.to = {
                  name: `${Services.users}.single`,
                  params: { id: this.value.entityId },
                  query: { currentTab: Services.tokens }
                }
                break
              }
            }

            break
          }
          case 'service': {
            let title = `${this.value.service}.title`
            switch (this.value.service) {
              case EVENTSHISTORY_ASSOCIATED_SERVICES.billingsUsers: {
                title = `${Services.eventsHistory}.services.billingsUsers`
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.contactListsContacts: {
                title = `${Services.eventsHistory}.services.${Services.contacts}`
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.keywordListsKeywords: {
                title = `${Services.eventsHistory}.services.${Services.keywords}`
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.permissionsUsers: {
                title = `${Services.eventsHistory}.services.${Services.permissions}`
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.settingsUserUsers: {
                title = `${Services.eventsHistory}.services.${Services.settingsUser}`
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.tokensUsers: {
                title = `${Services.eventsHistory}.services.${Services.tokens}`
                break
              }
            }

            result.value = this.getTranslate(title)
            result.link = true
            result.to = { name: this.value[key] }

            switch (this.value.service) {
              case EVENTSHISTORY_ASSOCIATED_SERVICES.tasks: {
                result.to = {
                  name: Services.billings,
                  query: { currentTab: Services.tasks }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.templates: {
                result.to = {
                  name: 'create'
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.contactLists: {
                result.to = {
                  name: `${Services.contacts}.single`,
                  params: { id: this.value.data.id }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.billingsUsers: {
                result.to = {
                  name: Services.billings,
                  query: { currentTab: Services.billings }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.contactListsContacts: {
                result.to = {
                  name: Services.contacts,
                  params: { id: this.value.data.ListId }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.keywordListsKeywords: {
                result.to = {
                  name: `${Services.keywordLists}.single`,
                  params: { id: this.value.data.ListId }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.permissionsUsers: {
                result.to = {
                  name: `${Services.users}.single`,
                  params: { id: this.value.entityId },
                  query: { currentTab: Services.permissions }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.settingsUserUsers: {
                const [ settingKey ] = this.value?.data?.new?.field?.split('.') || []
                result.to = {
                  name: `${Services.users}.single`,
                  params: { id: this.value.entityId },
                  query: {
                    currentTab: Services.settingsUser,
                    settingKey
                  }
                }
                break
              }
              case EVENTSHISTORY_ASSOCIATED_SERVICES.tokensUsers: {
                result.to = {
                  name: `${Services.users}.single`,
                  params: { id: this.value.entityId },
                  query: { currentTab: Services.tokens }
                }
                break
              }
            }

            break
          }
          case 'type': {
            result.value = this.getTranslate(`${Services.eventsHistory}.types.${this.value[key]}`)
            break
          }
        }
        rows.push(result)
      }

      return rows
    }
  },

  methods: {
    getCreatedAt() {
      const gt = this.value.data.createdAt
      const lt = new Date(gt).setSeconds(new Date(gt).getSeconds() + 1)

      return {
        $gt: gt,
        $lt: new Date(lt).toISOString()
      }
    }
  },

  render
}
